export default {"src":"/_next/static/media/kennekLogo.6fc68366.svg","height":191,"width":742,"blurWidth":0,"blurHeight":0};